import { render, staticRenderFns } from "./CameraSetupTab.vue?vue&type=template&id=d6cdb508"
import script from "./CameraSetupTab.vue?vue&type=script&lang=js"
export * from "./CameraSetupTab.vue?vue&type=script&lang=js"
import style0 from "./CameraSetupTab.vue?vue&type=style&index=0&id=d6cdb508&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports